import { useTranslation } from 'react-i18next';
import { ShoppingBag, ExternalLink, Shield } from 'lucide-react';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-warm-900 text-warm-300">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          <div className="space-y-4">
            <div className="flex items-center gap-2.5 text-white">
              <ShoppingBag className="w-5 h-5 text-brand-400" />
              <span className="font-display font-bold text-lg">CSSBuy Spreadsheet</span>
            </div>
            <p className="text-sm text-warm-400 leading-relaxed max-w-sm">{t('footer.description')}</p>
            <div className="flex items-center gap-2 text-xs text-warm-500">
              <Shield className="w-3.5 h-3.5" />
              <span>{t('safetyDisclaimer')}</span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">{t('footer.links')}</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-warm-400 hover:text-brand-400 transition-colors inline-flex items-center gap-1">
                  CSSBuy Spreadsheet <ExternalLink className="w-3 h-3" />
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-warm-400 hover:text-brand-400 transition-colors inline-flex items-center gap-1">
                  Buy It Now <ExternalLink className="w-3 h-3" />
                </a>
              </li>
              <li>
                <span className="text-sm text-warm-500">{t('footer.privacy')}</span>
              </li>
              <li>
                <span className="text-sm text-warm-500">{t('footer.terms')}</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">{t('footer.resources')}</h4>
            <ul className="space-y-2.5">
              <li><span className="text-sm text-warm-500">CSSBuy Review</span></li>
              <li><span className="text-sm text-warm-500">CSSBuy Shipping</span></li>
              <li><span className="text-sm text-warm-500">CSSBuy Warehouse</span></li>
              <li><span className="text-sm text-warm-500">CSSBuy QC</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-warm-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-warm-500">{t('footer.copyright')}</p>
          <div className="flex items-center gap-4 text-xs text-warm-500">
            <span>{t('footer.disclaimer')}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}